/// <amd-module name="TFS/Admin/Common/RestClient/PermissionsReport" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\permissionsreport.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as PermissionsReport from "../Contracts/PermissionsReport";

export interface IPermissionsReportRestClient extends IVssRestClient {
    /**
     * Request a permissions report to be created asyncronously
     * 
     * @param permissionsReportRequest - Request configuration to be included in the permissions report
     */
    createPermissionsReport(permissionsReportRequest: PermissionsReport.PermissionsReportRequest): Promise<any>;
    /**
     * Get a specific permissions report
     * 
     * @param id - The ID (GUID) of the permissions report
     */
    getPermissionsReport(id: string): Promise<PermissionsReport.PermissionsReport>;
    /**
     * Get a list of permissions reports
     * 
     */
    getPermissionsReports(): Promise<PermissionsReport.PermissionsReport[]>;
    /**
     * Download the json results of a permissions report
     * 
     * @param id - The ID (GUID) of the permissions report
     */
    download(id: string): Promise<ArrayBuffer>;
}

class PermissionsReportRestClient extends RestClientBase implements IPermissionsReportRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Request a permissions report to be created asyncronously
     * 
     * @param permissionsReportRequest - Request configuration to be included in the permissions report
     */
    public async createPermissionsReport(
        permissionsReportRequest: PermissionsReport.PermissionsReportRequest
        ): Promise<any> {

        return this.beginRequest<any>({
            apiVersion: "5.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/PermissionsReport/{id}",
            body: permissionsReportRequest
        });
    }

    /**
     * Get a specific permissions report
     * 
     * @param id - The ID (GUID) of the permissions report
     */
    public async getPermissionsReport(
        id: string
        ): Promise<PermissionsReport.PermissionsReport> {

        return this.beginRequest<PermissionsReport.PermissionsReport>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "_apis/PermissionsReport/{id}",
            routeValues: {
                id: id
            }
        });
    }

    /**
     * Get a list of permissions reports
     * 
     */
    public async getPermissionsReports(
        ): Promise<PermissionsReport.PermissionsReport[]> {

        return this.beginRequest<PermissionsReport.PermissionsReport[]>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "_apis/PermissionsReport/{id}"
        });
    }

    /**
     * Download the json results of a permissions report
     * 
     * @param id - The ID (GUID) of the permissions report
     */
    public async download(
        id: string
        ): Promise<ArrayBuffer> {

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "5.2-preview.1",
            httpResponseType: "application/octet-stream",
            routeTemplate: "_apis/PermissionsReport/{id}/download",
            routeValues: {
                id: id
            }
        });
    }

}

export const PermissionsReportClientName = "IPermissionsReportRestClient";

export function getPermissionsReportClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPermissionsReportRestClient {
    return pageContext.getRestClient<IPermissionsReportRestClient>(PermissionsReportClientName, options);
}

RestClients.add(PermissionsReportClientName, { 
    factory: PermissionsReportRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
